import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IPaginationOptions } from '../interfaces';
import { Store } from '@ngrx/store';

import * as PaginationActions from '../state/pagination.actions';
import * as paginationSelectors from '../state/paginaiton.selector';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  maxPages$: Observable<number>;
  paginationOptions$: Observable<IPaginationOptions>;
  perPage$: Observable<number>;

  constructor(
    private readonly store: Store<IPaginationOptions>,
  ) {
    this.maxPages$ = this.store.select(paginationSelectors.maxPages);
    this.paginationOptions$ = this.store.select(paginationSelectors.paginationSelector);
    this.perPage$ = this.store.select(paginationSelectors.perPage);
  }

  setMaxPages(maxPages: number): void {
    this.store.dispatch(PaginationActions.setMaxPages({ maxPages }));
  }

  setPerPage(perPage: number): void {
    this.store.dispatch(PaginationActions.setPerPage({ perPage }));
  }
}
